import { Language } from 'shared-components/src/settings/language/language.enum'

export default {
    apiUrl: process.env.REACT_APP_API_URL,
    lanternUrl: process.env.REACT_APP_LANTERN_URL,

    language: Language.Norwegian,
    localStorageLangKey: 'language',
}
